import Select from "../../../common/Select";

export default function AdminUserSelect(props: {
  selectedAdminId?: string;
  admins: { id: string; name: string }[];
  onChange: (adminId?: string) => void;
}) {
  return (
    <Select
      selected={props.selectedAdminId}
      backgroundColor={"black"}
      items={[
        { value: undefined, label: "All admins" },
        ...props.admins.map((admin) => ({
          value: admin.id,
          label: admin.name,
        })),
      ]}
      onChange={(value) => props.onChange(value as string | undefined)}
    />
  );
}
